const React = require("react");
const { Routes, Route, Navigate } = require("react-router-dom");
const { SynceeProvider } = require("./context/SynceeContext");
const { SynceeLayout } = require("./components/SynceeLayout");
const { DropshippingPlatforms } = require("./pages/DropshippingPlatforms");
const { DropshippingPlatformDetails } = require("./pages/DropshippingPlatformDetails");
const { DropshippingSynceeConnect } = require("./pages/DropshippingSynceeConnect");
const { DropshippingSuppliers } = require("./pages/DropshippingSuppliers");
const { DropshippingSupplierProducts } = require("./pages/DropshippingSupplierProducts");
const { DropshippingAllProducts } = require("./pages/DropshippingAllProducts");
const { DropshippingProductDetails } = require("./pages/DropshippingProductDetails");
const { DropshippingImportedProducts } = require("./pages/DropshippingImportedProducts");
const { DropshippingOrders } = require("./pages/DropshippingOrders");
const { DropshippingApiErrors } = require("./pages/DropshippingApiErrors");
const { DropshippingAdmin } = require("./pages/DropshippingAdmin");
const h = React.createElement;

const SynceeRoutes = () => h(Routes, null,
  h(Route, { element: h(SynceeLayout) },
    h(Route, { path: "syncee", element: h(DropshippingPlatforms) }),
    h(Route, { path: "syncee/details", element: h(DropshippingPlatformDetails) }),
    h(Route, { path: "syncee/connect", element: h(DropshippingSynceeConnect) }),
    h(Route, { path: "syncee/connected", element: h(DropshippingSynceeConnect) }),
    h(Route, { path: "syncee/suppliers", element: h(DropshippingSuppliers) }),
    h(Route, { path: "syncee/suppliers/:supplierId/products", element: h(DropshippingSupplierProducts) }),
    h(Route, { path: "syncee/products", element: h(DropshippingAllProducts) }),
    h(Route, { path: "syncee/products/:productId", element: h(DropshippingProductDetails) }),
    h(Route, { path: "syncee/imported", element: h(DropshippingImportedProducts) }),
    h(Route, { path: "syncee/orders", element: h(DropshippingOrders) }),
    h(Route, { path: "syncee/errors", element: h(DropshippingApiErrors) }),
    h(Route, { path: "syncee/admin", element: h(DropshippingAdmin) }),
    h(Route, { path: "syncee/*", element: h(Navigate, { to: "/dropshipping/syncee", replace: true }) })
  )
);

const SynceeApp = ({ baseUrl, token, translate, roleName }) => h(SynceeProvider, { baseUrl, token, translate, roleName }, h(SynceeRoutes));
module.exports = { SynceeApp, SynceeRoutes };
